import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals.js';


import AppContextProvider from './Context/AppContext.js';
import LocalizationContext from './Context/LocalizationContext.js';
import "react-datepicker/dist/react-datepicker.css";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import 'bootstrap/dist/css/bootstrap.min.css';

import {
    QueryClient,
    QueryClientProvider,
} from 'react-query'
import { SocketProvider } from './Context/SocketContext.js';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            cacheTime: 1 * 1000 * 60 * 60 // 30 mins
        }
    }
})


const div = document.getElementById('root');
const root = ReactDOM.createRoot(div);

root.render(
    <QueryClientProvider client={queryClient}>
        <AppContextProvider>
            <LocalizationContext>
                <SocketProvider>
                    <ToastContainer />
                    <App />
                </SocketProvider>
            </LocalizationContext>
        </AppContextProvider>
    </QueryClientProvider>
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
